import { Color } from 'csstype'
import React from 'react'

import { CidadaoListagemDesenvolvimentoInfantilQueryModel } from '../../../model/lista-tematica/model-desenvolvimentoInfantil'
import { AcompanhamentoCondicaoSaudeVacinasSection } from '../AcompanhamentoCondicaoSaudeVacinasSection'
import { GRUPOS_IMUNOBILIOGICO_DESENVOLVIMENTO_INFANTIL } from '../model-acompanhamentoCondicaoSaudeAccordion'
import { AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSection } from './AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSection'
import { AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSection } from './AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSection'
import { AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSection } from './AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSection'
import { AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSection } from './AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSection'

interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSectionProps {
  row: CidadaoListagemDesenvolvimentoInfantilQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSectionProps>
) {
  const { row, iconColor } = props
  const desenvolvimentoInfantil = row.cidadao?.cidadaoConsolidado?.desenvolvimentoInfantil
  const dataNascimento = row.dataNascimentoCidadao

  return (
    <>
      <AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSection
        dataNascimento={dataNascimento}
        consultas={desenvolvimentoInfantil?.consultas}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVacinasSection
        vacinas={desenvolvimentoInfantil?.vacinasAplicadas}
        grupos={GRUPOS_IMUNOBILIOGICO_DESENVOLVIMENTO_INFANTIL}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSection
        dataNascimento={dataNascimento}
        suplementacaoVitaminaA={desenvolvimentoInfantil?.suplementacaoVitaminaA}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilMedicoesSection
        qtdMedicoesPesoAltura={desenvolvimentoInfantil?.qtdMedicoesPesoAltura}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSection
        visitasDomiciliares={desenvolvimentoInfantil?.visitasDomiciliares}
        iconColor={iconColor}
      />
    </>
  )
}
